import api from './api'

export const chatService = {
  // Get all conversations
  async getConversations() {
    const response = await api.get('/chat')
    return response.data
  },

  // Get a specific conversation
  async getConversation(conversationId) {
    const response = await api.get(`/chat/${conversationId}`)
    return response.data
  },

  // Create a new conversation
  async createConversation(title, message) {
    const response = await api.post('/chat', {
      title,
      message
    })
    return response.data
  },

  // Update conversation (title, tags, etc.)
  async updateConversation(conversationId, updateData) {
    const response = await api.put(`/chat/${conversationId}`, updateData)
    return response.data
  },

  // Delete conversation
  async deleteConversation(conversationId) {
    const response = await api.delete(`/chat/${conversationId}`)
    return response
  },

  // Send message to conversation
  async sendMessage(conversationId, message) {
    const response = await api.post(`/chat/${conversationId}/message`, {
      message
    })
    return response.data
  }
}
